<template>
  <f7-nav-right class="langright">
    <f7-menu-item :text="$t('langKey')" dropdown class="langmenu">
      <f7-menu-dropdown right>
        <f7-menu-dropdown-item
          href="#"
          v-for="(item, i) in $i18n.messages"
          :key="i"
          :text="item.langName"
          @click="clicklang(item.key)"
        ></f7-menu-dropdown-item>
      </f7-menu-dropdown>
    </f7-menu-item>
  </f7-nav-right>
</template>
<script>
import Cookies from "js-cookie";
export default {
  name: "langButton",
  data() {
    return {};
  },
  props: {}, //接受父组件传值
  methods: {
    clicklang(key) {
      this.$i18n.locale = key;
      Cookies.set("language", key);
    },
  },
};
</script>
<style scoped>
.langright {
  z-index: 601;
}
.langmenu {
  background: transparent;
}
.menu-item-dropdown-opened {
  background: rgb(0, 0, 0, 0.9);
}
</style>